<template>
  <div
    class=" relative flex h-screen w-full flex-row justify-between overflow-hidden bg-Gray-100 md:gap-view-padding md:py-view-padding md:pr-view-padding 2xl:pr-8" :class="route.name?.startsWith('index') ? '':'parent-selector-element'">
    <NavigationTab />

    <NavigationMain :search-open="isSearchOpen"  />

    <div
      class="shift-to-left flex h-full max-h-full flex-0 z-0 grow flex-col gap-view-padding transition-transform duration-500">
      <UiIsOffline />

      <UiSearchResults class="max-md:hidden" @open="isSearchOpen = true" @close="isSearchOpen = false" />

      <!-- MAIN PAGE SLOT -->
      <div class="h-10 grow" :class="{
        'md:hidden': isSearchOpen
      }">
        <slot />
      </div>
    </div>

    
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const isSearchOpen = ref(false)
</script>

<style>
@import 'tailwindcss/theme' theme(reference);

.parent-selector-element:has(.navigation-is-open) .shift-to-left {
  @apply md:translate-x-64;
}
</style>
